import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Jumbotron, Row, FormControl, Button, Col } from 'react-bootstrap';
import { Table, Tr, Td, Th, Thead } from 'reactable';
import DateTimeField from 'react-bootstrap-datetimepicker';
import _ from 'lodash';
import moment from 'moment';

import { gettext } from '../../../i18n/service.js';
import * as actions from '../../../actions/appActions';
import { firstToUpper } from '../../../businessLogic/stringMethods.js';
import formatCamelCase from '../../../businessLogic/formatCamelCase.js';
import * as filtersForHistoryGenerator from '../../../businessLogic/filtersForHistoryGenerator.js';
import { getDashboardButtonStyle } from '../../../businessLogic/getButtonStyle.js';
import setOrderStatusColor from '../../../businessLogic/setOrderStatusColor.js';
import LoopbackHttp, { getUserId } from '../../../businessLogic/LoopbackHttp.js';
import * as Filters from '../../../businessLogic/orderListFilters.js';
import getTimestampRanges from '../../../businessLogic/getTimestampRanges.js';
import { columnsHistory } from '../../../constants/orderListColumns';

class HistoryComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      startDate: parseInt(moment().startOf('day').format('x')),
      endDate: parseInt(moment().endOf('day').format('x')),
      byValue: 'day'
    };
    _.bindAll(this, ['renderFilter', 'renderOrders', 'applyFilter']);
  }

  componentWillMount() {
    this.applyFilter(parseInt(moment().startOf('day').format('x')), parseInt(moment().endOf('day').format('x')));
  }


  


  applyFilter(startDate, endDate) {
    this.props.actions.startSpinner();

    let filters = [],
      action = '',
      ranges = getTimestampRanges(startDate, endDate);

    if (LoopbackHttp.isFleet) {
      filters.push(filtersForHistoryGenerator.filterForFleet(this.props.company.id, startDate, endDate));
      action = 'Orders';
    }
    else if (LoopbackHttp.isDispatcher) {
      filters.push(filtersForHistoryGenerator.filterForDispatcher(getUserId(), startDate, endDate));
      action = 'Orders';
    }
    else if (LoopbackHttp.isOperator) {
      filters.push(filtersForHistoryGenerator.filterForOperator(startDate, endDate));
      action = 'Operators/getOrders';
    }
    this.props.actions.getHistoryOrders(action, filters);
  }

  renderFilter() {

    return (
      <div className="filter_input" style={{ marginLeft: '1.5em', marginBottom: '2em', marginTop: '2em' }}>
        
          <Col md={3} sm={6} xs={8}>
            <DateTimeField
              mode="date"
              viewMode="days"
              name="dateValue"
              defaultText={moment(this.state.startDate).zone('+0300').format('L')}
              inputFormat="MM/DD/YYYY"
              inputProps={{
                name: "reportsDateFilter",
                className: "form-control filter_input"
              }}
              onChange={(event) => {
                this.setState({
                  startDate: parseInt(moment(parseInt(event)).startOf('day').format('x')),
                  endDate: parseInt(moment(parseInt(event)).endOf('day').format('x')),
                });
                this.applyFilter(parseInt(moment(parseInt(event)).startOf('day').format('x')), parseInt(moment(parseInt(event)).endOf('day').format('x')))
              }} />
          </Col>

      </div>
    );
  }

  renderOrders() {
    return _(this.props.ordersForHistory).sortBy('processedAt')
      .map((order) => {
        const { id } = order;
        // const platform = (order.createdByPlatformId)
        //   ? _.find(this.props.drivers, { id: order.createdByPlatformId })
        //   : undefined;
        // if (platform) {
        //   order['platform'] = platform;
        // }
        return (
          <Tr key={`order_${id}`}>

            <Td key={order.id} column={gettext('ORDER-#')} className={order.express ? 'red_border' : ''}>
              <div>
                <Button
                  className={getDashboardButtonStyle(order)}
                  onClick={() => this.props.renderModalForDetails(order)}>
                  {order.id.slice(order.id.length - 5, order.id.length)}
                </Button>
              </div>
            </Td>

            {_.map(columnsHistory, (c, i) => (
              <Td key={i} column={c.title} className={order.express ? 'red_border' : ''}>
                {c.id === 'status'
                  ? <span style={setOrderStatusColor(order.orderStatus)}>{c.render(order, this.props)}</span>
                  : <span>{c.render(order, this.props)}</span>
                }
              </Td>))
            }

          </Tr>
        );
      })
      .value();
  }

  render() {
    return (
      <div className="dispatcher_profile">
        <Jumbotron>
          <div className="item_head_title">
            <h3>{gettext('HISTORY')}</h3>
          </div>
          <Row>
            {this.renderFilter()}
          </Row>
            <Row>
              <Table
                className="dispatcherDashboardPageOrdersTable order_history_table"
                itemsPerPage={50}
                previousPageLabel={gettext('NAV-PREVIOUS')}
                nextPageLabel={gettext('NAV-NEXT')}
                pageButtonLimit={10}
                noDataText={gettext('NOTHING-TO-SHOW')}>

                <Thead>
                  <Th column={gettext('ORDER-#')}>
                    <label title={gettext('ORDER-#')}>{gettext('ORDER-#')}</label>
                    
                  </Th>

                  <Th column={gettext('DATE')}>
                    <label title={gettext('DATE')}>{gettext('CREATED-AT')}</label>
                    
                  </Th>
                  <Th column={gettext('DELIVERY-COST')}>
                    <label title={gettext('DELIVERY-COST')}>{gettext('DELIVERY-COST')}</label>
                    
                  </Th>
                  <Th column={gettext('CASH-ON-DELIVERY')}>
                    <label title={gettext('CASH-ON-DELIVERY')}>{gettext('CASH-ON-DELIVERY')}</label>
                    
                  </Th>
                  <Th column={gettext('CREATED-BY')}>
                    <label title={gettext('CREATED-BY')}>{gettext('CREATED-BY')}</label>
                    
                  </Th>
                  <Th column={gettext('DRIVER')}>
                    <label title={gettext('DRIVER')}>{gettext('DRIVER')}</label>
                    
                  </Th>
                  <Th column={gettext('STATUS')}>
                    <label title={gettext('STATUS')}>{gettext('STATUS')}</label>
                    
                  </Th>
                </Thead>

                {this.props.ordersForHistory.length > 0?this.renderOrders():''}

              </Table>
            </Row> 

        </Jumbotron>
        {this.state.modal}
      </div>
    );
  }
}


HistoryComponent.propTypes = {
};

function mapStateToProps(state) {
  return {
    ordersForHistory: state.appReducer.ordersForHistory,
    company: state.appReducer.company,
    vehicles: state.appReducer.vehicles,
    drivers: state.appReducer.drivers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoryComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/HistoryComponent.js